<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Buttons</h1>
    <h4>
      <a
        href="https://material.angular.io/components/button/examples"
        title="Material buttons"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div class="mb-4">
      <p>Basic (Link on page, Some action on page, ...)</p>
      <div>
        <button
          class="mr-3"
          mat-button>
          Basic
        </button>
        <button
          class="mr-3"
          color="primary"
          mat-button>
          Primary
        </button>
        <button
          class="mr-3"
          color="accent"
          mat-button>
          Accent
        </button>
        <button
          class="mr-3"
          color="warn"
          mat-button>
          Warn
        </button>
        <button
          class="mr-3"
          disabled
          mat-button>
          Disabled
        </button>
        <a
          href="https://www.google.com/"
          mat-button
          target="_blank"
          >Link</a
        >
      </div>
    </div>

    <div class="mb-4">
      <p>Raised (Primary action - focus for user, submit, ...)</p>
      <div>
        <button
          class="mr-3"
          mat-raised-button>
          Basic
        </button>
        <button
          class="mr-3"
          color="primary"
          mat-raised-button>
          Primary
        </button>
        <button
          class="mr-3"
          color="accent"
          mat-raised-button>
          Accent
        </button>
        <button
          class="mr-3"
          color="warn"
          mat-raised-button>
          Warn
        </button>
        <button
          class="mr-3"
          disabled
          mat-raised-button>
          Disabled
        </button>
        <a
          href="https://www.google.com/"
          mat-raised-button
          target="_blank"
          >Link</a
        >
      </div>
    </div>

    <div class="mb-4">
      <p>Stroked (Secondary action - not so important, Cancel, dismiss, ...)</p>
      <div>
        <button
          class="mr-3"
          mat-stroked-button>
          Basic
        </button>
        <button
          class="mr-3"
          color="primary"
          mat-stroked-button>
          Primary
        </button>
        <button
          class="mr-3"
          color="accent"
          mat-stroked-button>
          Accent
        </button>
        <button
          class="mr-3"
          color="warn"
          mat-stroked-button>
          Warn
        </button>
        <button
          class="mr-3"
          disabled
          mat-stroked-button>
          Disabled
        </button>
        <a
          href="https://www.google.com/"
          mat-stroked-button
          target="_blank"
          >Link</a
        >
      </div>
    </div>

    <div class="mb-4">
      <p>Flat (... not using ...)</p>
      <div>
        <button
          class="mr-3"
          mat-flat-button>
          Basic
        </button>
        <button
          class="mr-3"
          color="primary"
          mat-flat-button>
          Primary
        </button>
        <button
          class="mr-3"
          color="accent"
          mat-flat-button>
          Accent
        </button>
        <button
          class="mr-3"
          color="warn"
          mat-flat-button>
          Warn
        </button>
        <button
          class="mr-3"
          disabled
          mat-flat-button>
          Disabled
        </button>
        <a
          href="https://www.google.com/"
          mat-flat-button
          target="_blank"
          >Link</a
        >
      </div>
    </div>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Badge</h1>
    <h4>
      <a
        href="https://material.angular.io/components/badge/examples"
        title="Material badge"
        target="_blank"
        >Doc</a
      >
    </h4>

    <p>
      <span
        matBadge="4"
        matBadgeOverlap="false"
        >Text with a badge</span
      >
    </p>
    <p>
      <span
        matBadge="4"
        matBadgeColor="primary"
        matBadgeOverlap="false"
        >Text with a badge (primary color)</span
      >
    </p>
    <p>
      <span
        matBadge="4"
        matBadgeColor="accent"
        matBadgeOverlap="false"
        >Text with a badge (accent color)</span
      >
    </p>
    <p>
      <span
        matBadge="4"
        matBadgeColor="warn"
        matBadgeOverlap="false"
        >Text with a badge (warn color)</span
      >
    </p>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Material icons</h1>
    <h4>
      <a
        href="https://material.angular.io/components/icon/examples"
        title="Material icons"
        target="_blank"
        >Doc</a
      >
      <a
        class="pl-3"
        href="https://material.io/resources/icons/?style=baseline"
        title="Material icons set"
        target="_blank"
        >Material icons</a
      >
    </h4>

    <div>
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        >home</mat-icon
      >
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        color="primary"
        >home</mat-icon
      >
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        color="accent"
        >home</mat-icon
      >
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        color="warn"
        >home</mat-icon
      >
    </div>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Chips</h1>
    <h4>
      <a
        href="https://material.angular.io/components/chips/examples"
        title="Material chips"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div>
      <mat-chip-list aria-label="Fish selection">
        <mat-chip>One fish</mat-chip>
        <mat-chip color="primary">Primary fish</mat-chip>
        <mat-chip color="accent">Accent fish</mat-chip>
        <mat-chip color="warn">Warn fish</mat-chip>
        <mat-chip selected>One fish (selected)</mat-chip>
        <mat-chip
          color="primary"
          selected
          >Primary fish (selected)</mat-chip
        >
        <mat-chip
          color="accent"
          selected
          >Accent fish (selected)</mat-chip
        >
        <mat-chip
          color="warn"
          selected
          >Warn fish (selected)</mat-chip
        >
      </mat-chip-list>
    </div>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Progress spinner</h1>
    <h4>
      <a
        href="https://material.angular.io/components/progress-spinner/examples"
        title="Material chips"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div>
      <mat-progress-spinner
        diameter="45"
        mode="indeterminate"></mat-progress-spinner>
    </div>
    <div>
      <span>Primary</span>
      <mat-progress-spinner
        color="primary"
        diameter="45"
        mode="indeterminate"></mat-progress-spinner>
    </div>
    <div>
      <span>Accent</span>
      <mat-progress-spinner
        color="accent"
        diameter="45"
        mode="indeterminate"></mat-progress-spinner>
    </div>
    <div>
      <span>Warn</span>
      <mat-progress-spinner
        color="warrn"
        diameter="45"
        mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md-3">
    <h1>Progress Bar</h1>
    <h4>
      <a
        href="https://material.angular.io/components/progress-bar/examples"
        title="Material chips"
        target="_blank"
        >Doc</a
      >
    </h4>

    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div>
      <span>Primary</span>
      <mat-progress-bar
        color="primary"
        mode="indeterminate"></mat-progress-bar>
    </div>
    <div>
      <span>Accent</span>
      <mat-progress-bar
        color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
    <div>
      <span>Warn</span>
      <mat-progress-bar
        color="warn"
        mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</div>
